export default __webpack_public_path__ + "static/24-54d459f4a68dc1b0b0fb488a434d84b3.png";